// oxlint-disable-next-line no-restricted-imports
import { Modal as MantineModal, ModalProps } from "@mantine/core";

import { headings } from "#app/theme/v1/headings";

export const Modal = ({ styles, ...props }: ModalProps) => (
  <MantineModal
    {...props}
    title={props.title}
    styles={(theme, modalProps, ctx) => ({
      title: { ...headings.sizes.h2 },
      ...(typeof styles === "function" ? styles(theme, modalProps, ctx) : styles),
    })}
  />
);
